module.exports = __webpack_public_path__ + "img/140001.356d6b93.png";